<template>
  <div class="action-banner">
    <div class="columns is-vcentered is-gapless">
      <div class="column is-6">
        <div class="action-banner-content">
        <div class="text-content has-text-centered">
          <h2 class="action-banner-title has-text-centered">Own a <span class="gym-blue">gym?</span></h2>
            <p class="action-banner-subtitle has-text-centered mb-4">
            Sign up today and let 1000s of gym users see your club!
          </p>
          <router-link
            to="/register"
            class="button is-rounded is-large search-button slide-left button-shadow"
            >Sign up today!</router-link
          >
          </div>
        </div>
      </div>
      <div class="column is-6 action-banner-image is-hidden-mobile"></div>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style scoped>
.button-shadow {
  box-shadow: 0 1px 3px #6a6a6a !important;
}

.action-banner {
  margin-top: -3rem;
  width: 100vw;
  min-height: 65vh;
  background-color: #fff;
  overflow: hidden;
}

.content-div {
  max-width: 80%; 
  margin: auto;
  margin-bottom: 1rem; 
  height: 0.25rem; 
  background: #00c5fd;
}

@media (max-width: 768px) {
  .text-content {
    width: 100vw;
    background: rgba(0, 0, 0, 0.5);
    padding: 0.5rem;
  }
}

.action-banner-content {
  height: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}

.action-banner-image {
  background: url(../../assets/images/Stock/bruce-mars-gJtDg6WfMlQ-unsplash-cropped.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right;
  display: flex;
  min-height: 65vh;
  align-items: center;
}

.action-banner-subtitle {
  font-size: 1.5rem;
  color: #333333;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

@media only screen and (max-width: 1024px) {
  .action-banner-title {
    font-size: 2rem !important;
  }
}

@media only screen and (max-width: 768px) {

  .action-banner-content {
    background: url(../../assets/images/Stock/bruce-mars-gJtDg6WfMlQ-unsplash.jpg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    display: flex;
    min-height: 65vh;
    align-items: center;
  }

  .action-banner-title,
  .action-banner-subtitle {
    color: white;
    text-shadow: 0 0 6px #333333;
  }

  .action-banner {
    background: transparent;
  }

}
</style>
